import moment from 'moment';

export const printDateTime = (date?: number | Date | null): string => {
  if (date) {
    return moment(date).format('D MMM YYYY, HH:mm');
  } else {
    return '';
  }
};
